export default () => ({
  // JITX寻仓接口列表界面(寻仓订单下载)
  formConfig: {
    formValue: {
      numNumber: ''
    },
    formData: [
      {
        // version: '1.3',
        style: 'dropSelect',
        width: '24',
        isActive: true,
        isdisabled: false,
        inputList: [
          {
            childs: [{ colname: 'CP_C_SHOP_ID', refobjid: 50, valuedata: 2 }]
          }
        ],
        itemdata: {
          colid: 177300,
          colname: 'CP_C_SHOP_ID', // 当前字段的名称
          /* refcolval: {
            fixcolumn: 'CP_C_PLATFORM_ID',
            expre: 'equal',
            srccol: 'CP_C_SHOP_ID'
          }, */
          display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
          fkdisplay: 'drp', // 外键关联类型
          inputname: 'CP_C_SHOP_ID', // 这个是做中文类型的模糊查询字段，例如ENAME
          isfk: true, // 是否有fk键
          isnotnull: true, // 是否必填
          serviceId: 'r3-cp',
          name: t('店铺'), // 店铺 input前面显示的lable值
          readonly: false, // 是否可编辑，对应input   readonly属性
          aluedata: '' // 这个是选择的值
        }
      },
      {
        style: 'radio', // 单选框
        label: t('订单状态'), // 订单状态 前面字段
        width: '24', // 宽度
        value: 'order_status', // 绑定到formValue的值
        setRequired: '', // 必选标识,值不为required时无标识
        options: [
          // radio选项
          {
            value: 'NEW',
            label: t('新建') // 新建
          },
          {
            value: 'CONFIRMING',
            label: t('确认中') // 确认中
          },
          {
            value: 'CONFIRMED',
            label: t('确认为JITX') // 确认为JITX
          },
          {
            value: 'ROLLBACK',
            label: t('确认为非JITX') // 确认为非JITX
          }
        ]
      },
      {
        style: 'date',
        type: 'datetimerange', // 日期组件类型,默认为data  (daterange)为双日期区间选择
        value: 'query_date',
        label: t('下单时间'), // 下单时间
        width: '24',
        format: 'yyyy-MM-dd HH:mm:ss', // 格式参照burgeonui
        placeholder: ''
      }
    ],
    // 表单非空提示
    ruleValidate: {
      numNumber: [{ required: true, message: ' ', trigger: 'blur' }],
      query_date: [{ required: true, message: ' ', trigger: 'blur' }]
    }
  },
  init: self => {
    let date = new Date()
    let start = $utils.getFormatDate(date, 'yyyy-MM-dd HH:mm:00')
    let end = $utils.getFormatDate(
      new Date(date.setMinutes(date.getMinutes() + 30)),
      'yyyy-MM-dd HH:mm:00'
    )
    self.downLoadFormConfig.formValue.query_date = [start, end]
    $utils.formEmpty(self, 'downLoadFormConfig')
  },
  // 确定按钮
  determine: async self => {
    let formValue = self.downLoadFormConfig.formValue
    if (!self.downLoadFormConfig.formData[0].itemdata.pid) {
      self.$Message.warning(t('请选择需要下载的店铺')) // 请选择需要下载的店铺
      return false
    }
    const [start, end] = formValue.query_date
    if (!start) {
      self.$Message.warning(t('请选择下单时间！')) // 请选择下单时间
      return false
    }
    const timeDiff = end - start > 1800000
    if (timeDiff) {
      self.$Message.warning(t('下单时间范围不能超过半小时，请重新设置！')) // 下单时间范围不能超过半小时，请重新设置！
      return false
    }
    const param = {
      shop_id: self.downLoadFormConfig.formData[0].itemdata.pid, // 店铺id 必传
      status: self.downLoadFormConfig.formValue.order_status,
      start_time: start ? $utils.standardTimeConversiondateToStr(start) : '',
      end_time: end ? $utils.standardTimeConversiondateToStr(end) : '',
      table: self.$route.params.tableName // 当前表名 必传
    }
    const fromdata = new FormData()
    fromdata.append('param', JSON.stringify(param))
    // 寻仓订单下载
    const {
      data: { code, message }
    } = await self.service.interfacePlatform.downLoadVipDelivery(fromdata)
    if (code === 0) {
      self.$Message.success(message)
      self.$emit('confirmImport')
      self.$emit('closeActionDialog', true)
    }
  }
})
